import type { PropsWithChildren } from 'react';
import { Suspense } from 'react';

import { DotLoader } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../messages'

export interface IPageViewLoaderProps {}

export const PageViewLoader = ({
  children,
}: PropsWithChildren<IPageViewLoaderProps>) => {
  const intl = useProcurifyIntl()

  return (
    <Suspense
      fallback={
        <DotLoader
          aria-label={intl.formatMessage(messages.pageLoaderAriaLabel)}
        />
      }
    >
      {children}
    </Suspense>
  );
}

PageViewLoader.displayName = 'PageViewLoader'
